import graphqlClient from '@/graphql/graphql-client';
import { toPagingOnlyVariables } from '@/graphql/list-query';
import type { ListQueryVariables } from '@/graphql/types';
import { useQuery } from '@tanstack/react-query';

import {
  TaskManagerItemsDocument,
  type TaskManagerItemsQuery,
} from '@/graphql/generated/graphql';

export type TaskManagerItemRecord = NonNullable<
  NonNullable<TaskManagerItemsQuery['getTaskManagerItems']>['items']
>[number];
export type GetTaskManagerItemsResponse = TaskManagerItemsQuery;

export const useGetTaskManagerItems = (params?: ListQueryVariables<Record<string, unknown>>) => {
  const variables = toPagingOnlyVariables(params);
  return useQuery({
    queryKey: ['task-manager-items', variables],
    queryFn: () => graphqlClient.request(TaskManagerItemsDocument, variables),
  });
};

export const requestTaskManagerItems = (params?: ListQueryVariables<Record<string, unknown>>) => {
  const variables = toPagingOnlyVariables(params);
  return graphqlClient.request(TaskManagerItemsDocument, variables);
};

export const GET_TASK_MANAGER_QUERY = TaskManagerItemsDocument;
